module.exports = __webpack_public_path__ + "static/media/inter-light.b9920de0.woff";